<template lang="pug">
  .formpage
    .right_col(role='main')
      .page-title
        .title_left
          h2 フォーム管理
      .x_panel
        .x_content
          router-link(to='/dashboard/form/new').btn.btn-success 新規フォーム作成
          .ln_solid
          table.table.table-bordered.datatable
            tbody
              //- tr.active
              //-   th.icon 有効・無効
              //-   th フォーム名
              //-   th.icon 編集
              //-   th.icon 複製
              //-   th 埋め込みコード
              //-   th.icon 削除
              tr(v-for='(form, index) in forms' :id='form.id' :index='index' :valid='form.is_valid')
                // 有効・無効ボタン
                td
                  center
                    input(type='checkbox' name='valid_chk' v-model='form.is_valid' v-bind:true-value='1' v-bind:false-value='0'
                      data-size='' data-on-color='success' data-off-color='default' data-on-text='' data-off-text='' @click='isValidChange')
                //フォーム名
                td.form_link
                  router-link(:to="{ name: 'messages', params: { id: form.id } }") {{form.name}}
                //編集ボタン
                td.icontablebutton
                  router-link(:to="{ name: 'form', params: { id: form.id } }").tableicon.btn.btn-app.glaybutton
                    i.fa.fa-pencil-square-o(aria-hidden='true')
                      span 編集
                //コピーボタン
                td.icontablebutton
                  button.tableicon.btn.btn-app.glaybutton(@click='copyForm')
                    i.fa.fa-clone(aria-hidden='true')
                     span コピー
                //埋め込みコード表示ボタン(ポップアップ)
                td.icontablebutton
                  button.tableicon.btn.btn-app.glaybutton(href='#', type='button', data-toggle="modal", data-target="#codemodal"
                  :data-whatever='index')
                    i.fa.fa-code(aria-hidden='true')
                      span 埋め込みコード
                //削除ボタン
                td.icontablebutton
                  button.tableicon.btn.btn-app.deleteicon(@click='deleteForm')
                    i.fa.fa-times-circle(aria-hidden='true')
                      span 削除

          //埋め込みコード用ポップアップ
          #codemodal.modal.fade(tabindex='-1')
            .modal-dialog
              .modal-content
                .modal-header
                  button.close(type='button', data-dismiss='modal')
                    span ×
                  h4.modal-title 埋め込みコード
                  h5 こちらのコードをコピーし、貼り付けてご使用ください。
                .modal-body
                  //埋め込みコード表示エリア
                  textarea.codetextarea(rows='5', readonly)
                .modal-footer
                  button.customsmallbutton.btn.btn-success.copy-btn(type='button') クリップボードへコピー
</template>

<script>
import Authenticate from '@/service/Authenticate'
import $ from 'jquery'
import Request from '@/service/Request'
import Loader from '@/service/Loader'
import qs from 'querystring'
import Message from '@/service/Message'

export default {
  name: 'dashborad',
  data () {
    return {
      forms: []
    }
  },
  mounted () {
    let vue = this
    // modal dialog表示時に対象となる埋め込みコードをいれる
    $('#codemodal').on('show.bs.modal', function (event) {
      let targetIndex = $(event.relatedTarget).data('whatever')
      if (vue._data.forms[targetIndex].is_valid === '0') {
        Message.error(['無効のフォームの埋め込みコードは表示できません。', 'フォームを有効にしてから埋め込みコードを表示してください。'])
        return false
      }

      let urlHead = location.protocol + '//' + location.host
      let token = vue.forms[targetIndex].embed_token
      // 埋め込むテキストを構築
      let text = ''
      text += '<link rel=stylesheet href=' + urlHead + '/external/form.css>\n'
      text += '<div inquiry-form id="' + token + '" style="width: 600px; margin: auto;">\n'
      text += '<div v-show="isComplete" style="display:none">\n'
      text += '<p>お問合せいただきありがとうございます。</p>\n'
      text += '<p>担当者からの連絡をお待ちくださいますようお願い申し上げます。</p>\n'
      text += '</div>\n'
      text += '</div>\n'
      text += '<p style="display: none;">\n'
      text += '<script src=https://code.jquery.com/jquery-3.2.1.min.js><' + '/' + 'script>\n'
      text += '<script text=text/javascript src=https://www.promisejs.org/polyfills/promise-done-7.0.4.min.js><' + '/' + 'script>\n'
      text += '<script text=text/javascript src=https://cdnjs.cloudflare.com/ajax/libs/superagent/3.6.0/superagent.min.js><' + '/' + 'script>\n'
      text += '<script text=text/javascript src=https://cdnjs.cloudflare.com/ajax/libs/vue/2.4.2/vue.min.js><' + '/' + 'script>\n'
      text += '<script text=text/javascript src=https://unpkg.com/vuelidate@0.5.0/dist/validators.min.js><' + '/' + 'script>\n'
      text += '<script text=text/javascript src=' + urlHead + '/external/components.js><' + '/' + 'script>\n'
      text += '<script text=text/javascript src=' + urlHead + '/external/form.js><' + '/' + 'script>'
      text += '</p>'

      $(this).find('.codetextarea').text(text)
    })
    // 埋め込みコードのコピー
    $(document).on('click', '.copy-btn', function () {
      $('.codetextarea').select()
      document.execCommand('copy')
      Message.show('success', ['コードをコピーしました。'])
    })

    this.bind()
  },
  methods: {
    // データバインド
    bind () {
      this.$nextTick(() => { Loader.show() })
      let axios = Request.instance(true)
      let result = axios.get('/form')
      let vue = this
      this.forms = [] // 必要
      result.then((res) => {
        vue.forms = res.data
        // vue.$set(vue, 'forms', res.data)
        this.$nextTick(() => {
          // bootstrap switchの定義、on changeの処理もここで定義する
          $("[name='valid_chk']").bootstrapSwitch({
            size: 'small',
            onText: 'ON',
            offText: 'OFF'
          })
          .on('switchChange.bootstrapSwitch', function (e, state) {
            let formId = $(this).parents('tr').attr('id')
            vue.isValidChange(formId, state)
          })
          $('.bootstrap-switch-success').css('background-color', '#26B99A')
          Loader.hide()
        })
      })
    },
    isValidChange (id, status) {
      // サーバ情報等が不完全ならば有効にできない
      let index = $(event.target).parents('tr').attr('index')
      let targetDatas = this._data.forms[index]
      if (status) {
        // フォーム設定の必須要項の入力がなければエラーにする
        if (!targetDatas.notification_to || !targetDatas.smtp_mail_address || !targetDatas.smtp_server || !targetDatas.smtp_port || !targetDatas.smtp_user || !targetDatas.smtp_pass) {
          Message.show('error', ['フォームの送受信メール設定が不完全なため、フォームを有効にできません。'])
          $('tr[index=' + index + ']').find("[name='valid_chk']").bootstrapSwitch('state', false)
          // this.bind()
          return false
        }
      }
      // 更新
      this.$nextTick(() => { Loader.show() })
      let axios = Request.instance(true)
      let currentUser = Authenticate.currentUser()
      let self = this
      axios.put('/form/' + id + '/valid',
        qs.stringify({
          status: status,
          user: JSON.stringify(currentUser)
        })
      ).then((res) => {
        self.bind()
        // let message = res.data.form + 'を' + res.data.valid + 'にしました'
        // Message.show('success', [message])
      }).catch((error) => {
        this.$nextTick(() => { Loader.hide() })
        // dashboardへメッセージを送信
        Message.error(error.response.data.message)
      })
    },
    copyForm () {
      let formId = $(event.target).parents('tr').attr('id')
      let self = this
      $.confirm({
        title: '',
        content: 'フォームをコピーしますか？',
        columnClass: 'col-md-2 col-md-offset-5',
        type: 'dark',
        typeAnimated: true,
        buttons: {
          はい: {
            btnClass: 'btn-dark',
            action: function () {
              let axios = Request.instance(true)
              let currentUser = Authenticate.currentUser()
              axios.post('/form/' + formId + '/copy',
                qs.stringify({
                  user: JSON.stringify(currentUser)
                })
              ).then((res) => {
                self.bind()
                let message = res.data.form_name + 'をコピーしました'
                Message.show('success', [message])
              }).catch((error) => {
                // dashboardへメッセージを送信
                Message.error(error.response.data.message)
              })
            }
          },
          いいえ: function () {
          }
        }
      })
    },
    deleteForm () {
      let valid = $(event.target).parents('tr').attr('valid')
      if (valid === '1') {
        Message.show('error', ['有効状態のフォームは削除できません。'])
        return false
      }
      // 削除するformのid
      let formId = $(event.target).parents('tr').attr('id')
      let vue = this
      $.confirm({
        title: '',
        content: 'フォームを削除しますか？',
        columnClass: 'col-md-2 col-md-offset-5',
        type: 'dark',
        typeAnimated: true,
        buttons: {
          はい: {
            btnClass: 'btn-dark',
            action: function () {
              let axios = Request.instance(true)
              let result = axios.delete('/form/' + formId)
              result.then((res) => {
                vue.bind()
                Message.show('success', ['フォームを削除しました'])
              }).catch((error) => {
                Message.error(error.response.data.message)
              })
            }
          },
          いいえ: function () {
          }
        }
      })
    }
  },
  components: {
  }
}
</script>

<style lang="stylus" scoped>
#codemodal
  textarea
    width: 100%
td
  span
    line-height: 0px
    padding-left: 5px
.form_link:hover
  text-decoration: underline
// デフォルトスタイル無効化
.btn-app:focus
  box-shadow: none

// フォームボタン
.glaybutton
  background-color: #f7f7f7 !important
  box-shadow: 0 1px 0 #ded6d6
.glaybutton:hover
  background-color: #f3f2f2 !important
.glaybutton:active, .deleteicon:active
  top: 1px
  box-shadow: none
.deleteicon
  background-color: #ce2121 !important
  box-shadow: 0 1px 0 #ded6d6
  border: none !important
.deleteicon:hover
  background-color: #f33030 !important
</style>



// WEBPACK FOOTER //
// Forms.vue?2822cafc